<template>
  <el-card :body-style="{ padding: '0px' }">
      <div slot="header" class="file header">
            <img :src="require('./image/file-header.png')" class="header-icon" />
            <span class="header-title">
                Files
            </span>
            <span class="send-link" @click="addNew = true" v-if="getUserType !== 'observer'">
                <span>
                    <i>&#43;</i>
                    Add New
                </span>
            </span>
        </div>
        <FileTable :patient="patient" @add-new="addNew = true"></FileTable>
        <el-dialog
          :visible.sync="addNew"
          :append-to-body="true"
          :close-on-click-modal="false"
          class="send-now-modal"
          @close="closeNewFile"
          v-if="addNew"
          width="30%">
          <div slot="title">
              Add new File
          </div>
          <div>

              <div class="input-row">
                  <label>Select File Type</label>
                  <el-cascader
                    v-if="showMultiProviders"
                    class="category-cascader"
                    v-model="selectedProviderFileType"
                    :options="multiProviderFileCategories"
                    @change="handleCategoryChange"
                    size="small"
                    >
                  </el-cascader>
                  <el-select v-else size="mini" placeholder="Select From here" v-model="fileType">
                      <el-option
                          v-for="fileCategory in patientFileCategories"
                          :key="fileCategory.id"
                          :label="fileCategory.title"
                          :value="fileCategory.id">
                        </el-option>
                  </el-select>
                  <span class="error-text" v-if="this.fileType == '' && this.showError">
                        Please select file type
                    </span>
              </div>
              <div class="input-row" v-if="folderCategories.length > 0">
                  <label>Select File Folder (optional)</label>
                  <el-select size="mini" placeholder="Select From here" v-model="folderType">
                      <el-option
                          v-for="folderCategory in folderCategories"
                          :key="folderCategory.id"
                          :label="folderCategory.title"
                          :value="folderCategory.id">
                        </el-option>
                  </el-select>
              </div>
              <div class="input-row">
                  <label for="upload-file-name">Enter File Name</label>
                  <input id="upload-file-name" v-model="fileName" type="text"
                    placeholder="e.g. x-ray of knee" />
                    <span class="error-text" v-if="this.fileName == '' && this.showError">
                        Please enter file name
                    </span>
              </div>
              <div class="attach-file">
                    <span class="attach-title" for="uploadFileRecord">Attach File</span>
                    <label >
                        <div class="none" v-if="attachStatus === 'none'">
                            <span class="browse-button">
                                Browse File
                            </span>
                            or, drop file to attach
                        </div>
                        <div class="ongoing" v-else-if="attachStatus === 'ongoing'">
                            <LoadSpinner type="primary-light"></LoadSpinner>
                            {{ attachingFile.name }}
                        </div>
                        <div class="complete" v-else>
                            <div class="file-show">
                                <span class="name">
                                    {{ attachingFile.name }}
                                </span>
                                <el-button @click="resetAttachment" icon="el-icon-close" circle></el-button>
                            </div>
                            
                            <span class="success-status">
                                <TickIcon></TickIcon>
                                File Attached
                            </span>
                            
                        </div>
                        <input id="uploadFileRecord" type="file" ref="attachFile" name="file"
                            @change="doUpload" :disabled="attachStatus !== 'none'" v-show="attachStatus == 'none'">
                    </label>
                    <div class="input-row">
                        <span class="error-text" v-if="!this.uploadUrl && this.showError">
                            Please attach file
                        </span>
                    </div>
                    
              </div>
              
          </div>
          <div class="footer">
              <LoadingButton
                    type="primary"
                    size="small"
                    class="send-button"
                    @click="addNewFile"
                    :loading="creatingFile"
                    :loaded="hasCreatedFile">
                Add File
            </LoadingButton>
            <el-button type="text" size="small" class="cancel-button" @click="addNew = false">
                Cancel
            </el-button>
            
          </div>
        </el-dialog>
  </el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OverviewCard from '..'
import FileTable from './FileTable'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import TickIcon from '@/module/patient/icon/Tick.vue'
import LoadingButton from '@/module/component/LoadingButton.vue'
import FileHeader from './image/file-header.png'


export default {
    name: 'patient-file-card',
    extends: OverviewCard,

    data() {
        return {
            addNew: false,
            attachStatus: 'none',
            attachingFile: null,
            uploadUrl: null,
            fileName: '',
            fileType: '',
            folderType: '',
            creatingFile: false,
            hasCreatedFile: false,
            showError: false,
            selectedProviderFileType: [],
            selectedProvider: null,
            selectedProfile: null
        }
    },

    methods: {
        ...mapActions('provider', [
            'uploadFile',
            'createFile'
        ]),
        doUpload(uploadFile) {
            if (this.$refs.attachFile && this.$refs.attachFile.files.length > 0) {
                this.attachStatus = 'ongoing'
                this.attachingFile = this.$refs.attachFile.files[0]
                this.uploadFile({
                    file: this.attachingFile,
                    patientId: this.patient.id
                })
                .then((uploadUrl) => {
                    this.uploadUrl = uploadUrl
                    this.attachStatus = 'complete'
                })
                .catch((error) => {
                    this.attachStatus = 'none'
                })
            }
        },
        addNewFile() {
            if(this.fileName == '' || !this.uploadUrl || this.fileType == '') {
                this.showError = true
                return
            }
            let profile, provider
            if(this.provider) {
                provider = this.provider.provider
                profile = this.patientProviderProfileList.find(({provider}) => provider === this.getProvider.provider ).profile
            }
            else {
                provider = this.selectedProvider ? this.selectedProvider  : this.patientProviderProfileList[0].provider
                profile = this.selectedProfile ? this.selectedProfile : this.patientProviderProfileList[0].profile
            }
            const fileObj = {
                name: this.fileName,
                url: this.uploadUrl,
                profile,
                category_id: this.fileType,
                comment: ''
            }
            if(this.folderType)
                fileObj.folder = this.folderType
            this.creatingFile = true
            this.createFile({ 
                provider,
                patient: this.patient.id,
                fileObj
                })
                .then((response) => {
                    this.hasCreatedFile = true
                    this.creatingFile = false
                    this.addNew = false
                    this.closeNewFile()
                })
                .catch((error) => {
                    this.creatingFile = false
                })
        },
        closeNewFile() {
            this.attachStatus = 'none'
            this.attachingFile = null
            this.uploadUrl = null
            this.fileName = ''
            this.fileType = ''
            this.folderType = null
            this.creatingFile = false
            this.hasCreatedFile = false
            this.addNew = false
            this.selectedProvider = null
            this.selectedProfile = null
            this.selectedProviderRecordType = []
            this.showError = false
        },
        resetAttachment() {
            this.attachStatus = 'none'
            this.uploadUrl = null
        },
        handleCategoryChange(categoryValue) {
            if(categoryValue && Array.isArray(categoryValue) && categoryValue.length == 2) {
                const [provider, profile] = categoryValue[0].split(':')
                this.fileType = categoryValue[1]
                this.selectedProvider = provider
                this.selectedProfile = profile
            }
        }
    },
    computed: {
        ...mapGetters('provider', [
            'getPatientProviderProfileList',
            'getProviderNameById'
        ]),
        ...mapGetters('content', [
            'getProfileContent'
        ]),
        ...mapGetters(['getUserType']),
        patientProviderProfileList() {
            return this.getPatientProviderProfileList(this.patient.id)
        },
        patientFileCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1) {
                const fileCategories = this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'file_categories')
                if(fileCategories)
                    return fileCategories.sort((a, b) => a.title.localeCompare(b.title))
            }
            return []
        },
        multiProviderFileCategories() {
            try {
                return this.patientProviderProfileList
                    .map(({provider, profile}) => {
                        const value = provider + ':' + profile,
                            label = `${this.getProviderNameById(provider)} (${this.getContentKey('profile', profile, 'title')})`
                        const children = this.getProfileContent(profile, 'file_categories')
                            .map(({ id, title }) => ({ value: id, label: title }))
                        return {
                            value,
                            label,
                            children
                        }
                    })
            } catch (error) {
                console.error('Problem Calculating multiProviderQuestionnaireList ', error)
                return []
            }
        },
        folderCategories() {
            let currentProfile
            if(this.patientProviderProfileList.length === 1)
                currentProfile = this.patientProviderProfileList[0].profile
            else if(this.selectedProfile)
                currentProfile = this.selectedProfile
            if(currentProfile)
                return (this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'folder_categories')  || [])
                    .sort((a, b) => a.title.localeCompare(b.title, 'en', {sensitivity: 'base'}))
            return []
        }
    },

    components: {
        LoadSpinner,
        TickIcon,
        LoadingButton,
        FileTable,
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>

<style lang="css" scoped>
.el-card >>> .el-card__header {
    height: 25px;
}
.input-row .el-select >>> .el-input__inner{
    padding-left: 8px;
    font-size: 14px;
    font-weight: 600;
}
.input-row .el-select >>> .el-input__inner::placeholder {
    font-size: 12px;
    font-weight: 400;
}
.input-row .el-select >>> .el-select__caret{
    color: #666666;
}
</style>